<template>
  <Modal
    data-test="modal__error-container"
    class="dea-modal-overlay--error dea-modal--no-footer"
    :visible="visible"
    @modalClose="$emit('close-modal')"
  >
    <template slot="title">Si è verificato un errore</template>
    <template slot="content">
      <p>Gli eventi formazione sono riservati a docenti a dirigenti. Accedi con un altro account.</p>
      <div class="dea-modal__cta">
        <Buttons class="dea-button--medium dea-button--right" @click="logout()">Accedi</Buttons>
      </div>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";
import { createFocusTrap } from "focus-trap";
import userLogout from "~/helpers/userLogout";

export default {
  name: "StudentParentModal",
  components: { Buttons, Modal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cookieOptions: { path: "/", domain: ".deascuola.it", secure: true },
      sessionCookieName: "sessionId",
      historyCookieName: "hubEncryptedUser",
      loginCookieName: "bcejwt.loginToken",
      focusTrap: null,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.focusTrap === null) {
            this.focusTrap = createFocusTrap(this.$el, {
              onDeactivate: () => {
                this.$emit("close-modal");
              },
              onPostDeactivate: () => {
                this.focusTrap = null;
              },
              escapeDeactivates: true,
              allowOutsideClick: true,
            });
            this.focusTrap.activate();
          }
        });
      } else if (this.focusTrap) {
        this.focusTrap.deactivate();
      }
    },
  },
  beforeDestroy() {
    if (this.focusTrap) this.focusTrap.deactivate();
  },
  methods: {
    logout() {
      userLogout();
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.dea-modal-overlay--error {
  .dea-modal {
    @include media("<=s") {
      top: 33%;
      width: 90%;
    }
  }

  .dea-modal__close-button {
    display: none;
  }
}

.dea-modal__cta {
  margin-top: $space-small;
  text-align: right;
}
</style>
